import 'ui-theme/widgets/publication-content/js/publication-content';

(function () {
    UX.loader.additionalController = function () {
        var $body = $('body');
        $body.on('click', '.author-information-section .expand-link', function (e) {
            e.preventDefault();
            const $accordionTab = $('.author-information-section .accordion-tabbed__tab');
            const $accordionControl = $('.author-information-section .accordion-tabbed__control');
            const $accordionContent = $('.author-information-section .accordion-tabbed__content');
            const $expandlink = $(this);

            if ($expandlink.data('isExpanded') === 'true') {
                $accordionTab.removeClass('js--open');
                $accordionControl.attr('aria-expanded', 'false');
                $expandlink.data('isExpanded', 'false');
                $accordionContent.slideUp(200);
                $expandlink.find('a').text('Expand All');
            } else {
                $accordionTab.addClass('js--open');
                $accordionControl.attr('aria-expanded', 'true');
                $expandlink.data('isExpanded', 'true');
                $accordionContent.slideDown(200);
                $expandlink.find('a').text('Collapse All');
            }
        });
        const $openAaccess = $('.license-p');
        const $openAaccessdiv = $('.copyright');
        if ($openAaccess.length) {
            $openAaccessdiv.before(`<div class="section"> ${$openAaccess.html()} </div>`);
        }
    };
})();
